import { createContext } from 'react';
var MenuContext = /*#__PURE__*/createContext({
  prefixCls: '',
  firstLevel: true,
  inlineCollapsed: false
});
export default MenuContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/menu/MenuContext.js
// module id = 151
// module chunks = 0